import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect — ``/workspace/dxf-library`` was a standalone CAD library
 * route. May 28, 2026 the surface was collapsed into the canonical
 * ``/workspace/technical`` hub (sub-tab "drawings"). Existing deep links,
 * bookmarks and old conversation references continue to work because we
 * redirect on ``beforeLoad`` — no React render of this file happens.
 */
export const Route = createFileRoute("/_authed/workspace/dxf-library")({
  beforeLoad: () => {
    throw redirect({
      to: "/workspace/technical",
      search: { sub: "drawings" },
    });
  },
});
